// DEV-61. Фронтовая половина РГ-06 (восстановление доступа).
//
// Здесь собрано то, что одинаково нужно и форме запроса, и странице /recovery,
// и что можно проверить без браузера: правила пароля (те же, что на сервере
// в POST /registration/complete и POST /password-recovery/confirm: от 8 до 20
// знаков) и разбор признаков из адреса ссылки.

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 20;

/** Ответ запроса восстановления не зависит от того, есть ли учётная запись. */
export const RECOVERY_REQUEST_ANSWER =
  "если адрес зарегистрирован, на него отправлена ссылка для восстановления доступа";

/** Общий отказ по ссылке: и «истекла», и «уже использована», и «не найдена». */
export const RECOVERY_INVALID_LINK_MESSAGE = "ссылка недействительна или устарела";

export const RECOVERY_PASSWORD_RULES_MESSAGE =
  `пароль от ${PASSWORD_MIN_LENGTH} до ${PASSWORD_MAX_LENGTH} знаков`;

export const RECOVERY_PASSWORD_MISMATCH_MESSAGE = "пароли не совпадают";

/**
 * Правило пароля то же, что при регистрации. Возвращает текст отказа или null.
 */
export function passwordError(password: string, confirmation?: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH || password.length > PASSWORD_MAX_LENGTH) {
    return RECOVERY_PASSWORD_RULES_MESSAGE;
  }

  if (confirmation !== undefined && password !== confirmation) {
    return RECOVERY_PASSWORD_MISMATCH_MESSAGE;
  }

  return null;
}

export interface RecoveryParams {
  requestId: number | null;
  token: string | null;
}

/**
 * Разбирает `?request=<id>&token=<признак>` из адреса ссылки. Пустые или
 * неправдоподобные значения дают null — тогда страница показывает общий отказ,
 * не пытаясь ничего подтвердить.
 */
export function parseRecoveryParams(search: string): RecoveryParams {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);

  const rawRequest = params.get("request");
  const rawToken = params.get("token");

  const trimmedRequest = (rawRequest ?? "").trim();
  const requestId = /^\d+$/.test(trimmedRequest) ? Number(trimmedRequest) : null;

  const token = rawToken && rawToken.trim() !== "" ? rawToken : null;

  return { requestId, token };
}
